import { createReducer, on } from '@ngrx/store';
import { AnalyticsUIActions } from 'app/main/analytics/actions';
import { AnalyticsUIState } from 'app/main/analytics/analytics.types';

const initialState: AnalyticsUIState = {
    selectedTab: 0,
    report: {
        selectedGroup: null
    }
};

export const reducer = createReducer(
    initialState,
    on(
        AnalyticsUIActions.analyticsSetSelectedTab,
        (state, { selectedTab }): AnalyticsUIState => ({
            ...state,
            selectedTab
        })
    ),
    on(
        AnalyticsUIActions.analyticsReportSetSelectedGroup,
        (state, { entry }): AnalyticsUIState => ({
            ...state,
            report: {
                ...state.report,
                selectedGroup: entry
            }
        })
    )
);
